import Router from 'components/Router'
import { LoginContextProvider } from 'contexts/LoginContext'
import { NotificationProvider } from 'contexts/NotificationContext'
import { CompanyProvider } from 'contexts/CompanyContext'
import useLogin from 'contexts/LoginContext'

function SessionNotifications({ children }) {
  const { isLogged } = useLogin()

  return (
    <NotificationProvider enabled={isLogged}>
      {children}
    </NotificationProvider>
  )
}

function App() {
  return (
    <CompanyProvider>
      <LoginContextProvider>
        <SessionNotifications>
          <Router />
        </SessionNotifications>
      </LoginContextProvider>
    </CompanyProvider>
  );
}

export default App;
